export default __webpack_public_path__ + "static/media/220.cd47a688.jpeg";